interface MonadIconProps {
  className?: string
}

export function MonadIcon({ className }: MonadIconProps) {
  return (
    <svg viewBox="0 0 182 184" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <path
        d="M90.5358 0C64.3911 0 0 65.2598 0 91.7593C0 118.259 64.3911 183.52 90.5358 183.52C116.681 183.52 181.073 118.258 181.073 91.7593C181.073 65.2609 116.682 0 90.5358 0ZM76.4273 144.23C65.4024 141.185 35.7608 88.634 38.7655 77.4599C41.7703 66.2854 93.62 36.2439 104.645 39.2892C115.67 42.3341 145.312 94.8846 142.307 106.059C139.302 117.234 87.4522 147.276 76.4273 144.23Z"
        fill="#6E54FF"
      />
    </svg>
  )
}
